module.exports = __webpack_public_path__ + "img/sichuan-air.8f4a6752.png";